import styled from 'styled-components';
import { colorWhite, mediaQueryMobileLargeMin, mediaQueryDesktopMin } from 'styleUtils';
export var BankCardListWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-13enpwb-0"
})(["width:100%;&:not(:last-child){margin:0 0 8px 0;}"]);
export var ListWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-13enpwb-1"
})(["display:flex;flex-direction:column;width:100%;padding:24px 16px 0 16px;background:", ";"], colorWhite);
export var MoreCardsButtonWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-13enpwb-2"
})(["width:100%;margin:1px 0 0 0;padding:16px 0;background:", ";text-align:center;"], colorWhite);
export var MoreCardsButton = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-13enpwb-3"
})(["display:inline-block;width:120px;height:16px;"]);
export var CompanyInfoWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-13enpwb-4"
})(["display:flex;flex-direction:row;align-items:flex-start;width:100%;margin:0 0 24px 0;"]);
export var CompanyLogoWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-13enpwb-5"
})(["flex:none;width:32px;height:32px;"]);
export var CompanyData = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-13enpwb-6"
})(["display:flex;flex-direction:column;margin:0 0 0 16px;"]);
export var CompanyDataTitle = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-13enpwb-7"
})(["width:120px;height:14px;@media ", "{width:264px;height:16px;}"], mediaQueryMobileLargeMin);
export var CompanyDataMore = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-13enpwb-8"
})(["display:flex;flex-direction:row;align-items:center;margin:6px 0 0 0;width:184px;height:12px;@media ", "{width:192px;}"], mediaQueryMobileLargeMin);
export var ProductsInfoWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-13enpwb-9"
})(["width:100%;"]);
export var ProductHead = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-13enpwb-10"
})(["width:200px;height:20px;margin:0 0 24px 0;@media ", "{width:264px;}"], mediaQueryMobileLargeMin);
export var ProductMainInfo = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-13enpwb-11"
})(["display:flex;flex-wrap:wrap;width:100%;@media ", "{flex-wrap:nowrap;justify-content:space-between;}"], mediaQueryMobileLargeMin);
export var ProductMainInfoBlock = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-13enpwb-12"
})(["width:40%;margin:0 10% 24px 0;height:40px;@media ", "{width:20%;margin:0 0 24px 0;}"], mediaQueryMobileLargeMin);
export var MoreInfoFooterWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-13enpwb-13"
})(["display:flex;margin:0 0 24px 0;flex-direction:column;justify-content:space-between;@media ", "{flex-direction:row;}"], mediaQueryMobileLargeMin);
export var ProductMainInfoBenefitsBlock = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-13enpwb-14"
})(["display:flex;flex-direction:row;flex-wrap:wrap;margin:-4px;width:100%;"]);
export var ProductMainInfoBenefit = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-13enpwb-15"
})(["width:200px;height:24px;margin:4px;@media ", "{width:268px;}@media ", "{width:200px;}"], mediaQueryMobileLargeMin, mediaQueryDesktopMin);
export var MoreInfoButtonWrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-13enpwb-16"
})(["padding:0 0 0 4px;margin-top:24px;height:16px;width:200px;@media ", "{margin-left:auto;margin-bottom:0;margin-top:0;width:164px;height:24px;}@media ", "{margin-bottom:auto;}"], mediaQueryMobileLargeMin, mediaQueryDesktopMin);